import { createContext, useContext } from "react";
import { CarBotbSubModalContext } from "../types";

export const BotbPassModalContext = createContext<CarBotbSubModalContext>({
  allPackages: [],
  preSubscriptionData: {
    features: [],
    header: {
      legalText: "",
      subtitlep1: "",
      subtitlep2: "",
      subtitlep3: "",
      title: "",
      video: "",
      videoMobile: "",
    },
    offer: { bonus: "", description: "", expireTime: 0, headline: "", offerImage: "", offerTitle: "" },
  },
  preSubscriptionDataLoading: true,
  closeModal: () => {},
  prizeTicketProps: {
    CompetitionType: 0,
    CompetitionTypePrefix: "",
    PostalEntryText: "",
    PrizeTicketModel: {
      PrizeBoostPromoText: "",
      CompetitionId: 0,
      CompetitionPictureTitle: "",
      ContentNodeId: 0,
      CurrencySymbol: "",
      DefaultTicketCount: 0,
      FormattedOriginalPrice: "",
      FormattedPrice: "",
      FormattedPriceWithoutCurrency: "",
      ImageUrl: "",
      IncrementAmount: 0,
      IsMultiBuyActive: false,
      IsMultiBuyForFirstPurchase: false,
      IsRewardTicket: false,
      Make: "",
      MaxTicketQuantity: 0,
      Model: "",
      MultiBuyEndDay: 0,
      MultiBuyEndHour: 0,
      MultiBuyEndMinute: 0,
      MultiBuyEndMonth: 0,
      MultiBuyEndSecond: 0,
      MultiBuyEndYear: 0,
      MultiBuyLowerPercent: 0,
      MultiBuyLowerQuantity: 0,
      MultiBuyUpperPercent: 0,
      MultiBuyUpperQuantity: 0,
      OverrideDiscountValue: "",
      PercentOffValue: 0,
      PriceWithoutCurrency: 0,
      PrizeBoostEndDate: 0,
      PrizeBoostImageUrl: "",
      PrizeBoostLowerQuantity: 0,
      PrizeBoostLowerValue: 0,
      PrizeBoostUpperQuantity: 0,
      PrizeBoostUpperValue: 0,
      PrizeId: 0,
      ProductId: 0,
      QuickBuyFirstButtonValue: 0,
      QuickBuySecondButtonValue: 0,
      QuickBuyThirdButtonValue: 0,
      RemainingRewardTickets: {
        AllAvailableRewardTickets: 0,
        HasRewardTicketsInCart: false,
        RewardTickets: [],
        ServerTime: undefined,
      },
      ShowInstantWinText: false,
      ShowTicketMaxOnSlider: false,
      StartAmount: 0,
      SubscriptionTickets: 0,
      SupportsMultibuy: false,
      TicketSelectorMode: undefined,
      UserCanPurchase: false,
      UserPurchaseMessage: "",
    },
    ShowSubscriptionTab: false,
    UTMForSubscriptionDrawer: "",
    UTMForSubscriptionTab: "",
  },
  place: "",
});

export const useBotbPassDrawerContext = () => useContext(BotbPassModalContext);
